export default "__VITE_ASSET__UFKnh$41__"